export const SubReddits = [
    {
        type: "Reddit",
        name: "⭐️ /r/Vegan",
        category: "",
        author: "",
        description: "the largest vegan community on the internet",
        link: "https://www.reddit.com/r/vegan/",
        "": "",
    },
    {
        type: "Reddit",
        name: "/r/VeganRecipes",
        category: "",
        author: "",
        description: "find 100% plant based recipes",
        link: "https://www.reddit.com/r/veganrecipes/",
        "": "",
    },
    {
        type: "Reddit",
        name: "/r/VeganFitness",
        category: "",
        author: "",
        description: "discuss all things related to vegan fitness",
        link: "https://www.reddit.com/r/veganfitness/",
        "": "",
    },
    {
        type: "Reddit",
        name: "/r/DebateAVegan",
        category: "",
        author: "",
        description: "debate questions and discussions revolving veganism",
        link: "https://www.reddit.com/r/debateavegan/",
        "": "",
    },
    {
        type: "Reddit",
        name: "⭐️ /r/VeganActivism",
        category: "",
        author: "",
        description:
            "get active with your vegan activist community and make a difference",
        link: "https://www.reddit.com/r/VeganActivism/",
        "": "",
    },
    {
        type: "Reddit",
        name: "/r/ZeroWasteVegans",
        category: "",
        author: "",
        description: "discuss zero waste with a focus on veganism",
        link: "https://www.reddit.com/r/ZeroWasteVegans/",
        "": "",
    },
    {
        type: "Reddit",
        name: "/r/VeganFoodPorn",
        category: "",
        author: "",
        description: "find and share beautiful pictures of vegan food",
        link: "https://www.reddit.com/r/VeganFoodPorn/",
        "": "",
    },
    {
        type: "Reddit",
        name: "/r/VeganBaking",
        category: "",
        author: "",
        description: "share and discuss vegan backing recipes",
        link: "https://www.reddit.com/r/VeganBaking",
        "": "",
    },
    {
        type: "Reddit",
        name: "/r/Vegan",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/Vegan",
    },
    {
        type: "Reddit",
        name: "/r/Animalliberation",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Animalliberation",
    },
    {
        type: "Reddit",
        name: "/r/AnimalLiberationFront",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/AnimalLiberationFront",
    },
    {
        type: "Reddit",
        name: "/r/AnimalRights",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/AnimalRights",
    },
    {
        type: "Reddit",
        name: "/r/AnimalWelfare",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/AnimalWelfare",
    },
    {
        type: "Reddit",
        name: "/r/ARActivism",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/ARActivism",
    },
    {
        type: "Reddit",
        name: "/r/BanFactoryFarming",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/BanFactoryFarming",
    },
    {
        type: "Reddit",
        name: "/r/EffectiveAltruism",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/EffectiveAltruism",
    },
    {
        type: "Reddit",
        name: "/r/EAAnimalAdvocacy",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/EAAnimalAdvocacy",
    },
    {
        type: "Reddit",
        name: "/r/Ethical_Living",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Ethical_Living",
    },
    {
        type: "Reddit",
        name: "/r/Ethics",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Ethics",
    },
    {
        type: "Reddit",
        name: "/r/FactoryFarms",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/FactoryFarms",
    },
    {
        type: "Reddit",
        name: "/r/FoodNotBombs",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/FoodNotBombs",
    },
    {
        type: "Reddit",
        name: "/r/StopSpeciesism",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/StopSpeciesism",
    },
    {
        type: "Reddit",
        name: "/r/SocialismAndVeganism",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/SocialismAndVeganism",
    },
    {
        type: "Reddit",
        name: "/r/VeganAnarchistPOC",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganAnarchistPOC",
    },
    {
        type: "Reddit",
        name: "/r/Veganfeminist/",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Veganfeminist/",
    },
    {
        type: "Reddit",
        name: "/r/VeganActivism",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/VeganActivism",
    },
    {
        type: "Reddit",
        name: "/r/VeganArchism",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/VeganArchism",
    },
    {
        type: "Reddit",
        name: "/r/Veganuary",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Veganuary",
    },
    {
        type: "Reddit",
        name: "/r/VeganPOC",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganPOC",
    },
    {
        type: "Reddit",
        name: "/r/VeganLobby",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganLobby",
    },
    {
        type: "Reddit",
        name: "/r/ZeroWaste/",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/ZeroWaste/",
    },
    {
        type: "Reddit",
        name: "/r/Composting",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/Composting",
    },
    {
        type: "Reddit",
        name: "/r/Cowspiracy",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Cowspiracy",
    },
    {
        type: "Reddit",
        name: "/r/Ecoevents",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Ecoevents",
    },
    {
        type: "Reddit",
        name: "/r/Environment",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/Environment",
    },
    {
        type: "Reddit",
        name: "/r/PlantBased4ThePlanet",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/PlantBased4ThePlanet",
    },
    {
        type: "Reddit",
        name: "/r/Sustainability",
        category: "Reddit",
        author: "",
        description: "50,000+ subscribers",
        link: "https://www.reddit.com/r/Sustainability",
    },
    {
        type: "Reddit",
        name: "/r/VeganScience",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganScience",
    },
    {
        type: "Reddit",
        name: "/r/ZeroWasteVegans",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/ZeroWasteVegans",
    },
    {
        type: "Reddit",
        name: "/r/AntiConsumption",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/AntiConsumption",
    },
    {
        type: "Reddit",
        name: "/r/ForksOverKnives",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/ForksOverKnives",
    },
    {
        type: "Reddit",
        name: "/r/Gardening",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/Gardening",
    },
    {
        type: "Reddit",
        name: "/r/NutritionFacts",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/NutritionFacts",
    },
    {
        type: "Reddit",
        name: "/r/VeganAthletes",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganAthletes",
    },
    {
        type: "Reddit",
        name: "/r/VeganDoctors",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganDoctors",
    },
    {
        type: "Reddit",
        name: "/r/VeganFitness",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/VeganFitness",
    },
    {
        type: "Reddit",
        name: "/r/VeganKeto",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/VeganKeto",
    },
    {
        type: "Reddit",
        name: "r/VeganRunners",
        category: "Reddit",
        author: "",
        description: "",
        link: "r/VeganRunners",
    },
    {
        type: "Reddit",
        name: "/r/Vegan1200isPlenty",
        category: "Reddit",
        author: "",
        description: "50,000+ subscribers",
        link: "https://www.reddit.com/r/Vegan1200isPlenty",
    },
    {
        type: "Reddit",
        name: "/r/Vegan1500isPlenty",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Vegan1500isPlenty",
    },
    {
        type: "Reddit",
        name: "/r/WFPB",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/WFPB",
    },
    {
        type: "Reddit",
        name: "/r/WholeFoods",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/WholeFoods",
    },
    {
        type: "Reddit",
        name: "/r/WholefoodsPlantbased",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/WholefoodsPlantbased",
    },
    {
        type: "Reddit",
        name: "/r/Agriculture",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/Agriculture",
    },
    {
        type: "Reddit",
        name: "/r/AnimalIndustry",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/AnimalIndustry",
    },
    {
        type: "Reddit",
        name: "/r/AnimalIntelligence",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/AnimalIntelligence",
    },
    {
        type: "Reddit",
        name: "/r/ARLAW",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/ARLAW",
    },
    {
        type: "Reddit",
        name: "/r/Casomorphine",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Casomorphine",
    },
    {
        type: "Reddit",
        name: "/r/Cooperatives",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/Cooperatives",
    },
    {
        type: "Reddit",
        name: "/r/Mycology",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/Mycology",
    },
    {
        type: "Reddit",
        name: "/r/Permaculture",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/Permaculture",
    },
    {
        type: "Reddit",
        name: "/r/VeganFashion",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganFashion",
    },
    {
        type: "Reddit",
        name: "/r/VeganFashionAdvice",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganFashionAdvice",
    },
    {
        type: "Reddit",
        name: "/r/VeganParenting",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganParenting",
    },
    {
        type: "Reddit",
        name: "/r/VeganRights",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganRights",
    },
    {
        type: "Reddit",
        name: "/r/VeganScience",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganScience",
    },
    {
        type: "Reddit",
        name: "/r/Vegan_Travel",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Vegan_Travel",
    },
    {
        type: "Reddit",
        name: "r/AccidentallyVegan",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "r/AccidentallyVegan",
    },
    {
        type: "Reddit",
        name: "/r/Veganaww",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Veganaww",
    },
    {
        type: "Reddit",
        name: "/r/VeganChill",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/VeganChill",
    },
    {
        type: "Reddit",
        name: "/r/DrunkVegans",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/DrunkVegans",
    },
    {
        type: "Reddit",
        name: "/r/LateStageCarnism",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/LateStageCarnism",
    },
    {
        type: "Reddit",
        name: "/r/ShittyVeganFoodPorn",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/ShittyVeganFoodPorn",
    },
    {
        type: "Reddit",
        name: "/r/Veghumor",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Veghumor",
    },
    {
        type: "Reddit",
        name: "/r/Vegproblems",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Vegproblems",
    },
    {
        type: "Reddit",
        name: "/r/Vegmeme",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Vegmeme",
    },
    {
        type: "Reddit",
        name: "/r/Veg",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/Veg",
    },
    {
        type: "Reddit",
        name: "/r/VeggieTeens",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeggieTeens",
    },
    {
        type: "Reddit",
        name: "/r/VeganDating",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganDating",
    },
    {
        type: "Reddit",
        name: "/r/VeganR4R/",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganR4R/",
    },
    {
        type: "Reddit",
        name: "/r/VeganMentor",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganMentor",
    },
    {
        type: "Reddit",
        name: "/r/Veganexchange/",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Veganexchange/",
    },
    {
        type: "Reddit",
        name: "/r/VeganGaming",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganGaming",
    },
    {
        type: "Reddit",
        name: "/r/VeganHumor",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganHumor",
    },
    {
        type: "Reddit",
        name: "/r/Vegan_irl",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Vegan_irl",
    },
    {
        type: "Reddit",
        name: "/r/VeganVideos",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganVideos",
    },
    {
        type: "Reddit",
        name: "/r/Animal_Sanctuary",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/Animal_Sanctuary",
    },
    {
        type: "Reddit",
        name: "/r/Likeus",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/Likeus",
    },
    {
        type: "Reddit",
        name: "/r/VegansGoneWild",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VegansGoneWild",
    },
    {
        type: "Reddit",
        name: "/r/BudgetVeggie",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/BudgetVeggie",
    },
    {
        type: "Reddit",
        name: "/r/EatCheapandVegan",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/EatCheapandVegan",
    },
    {
        type: "Reddit",
        name: "/r/FarmersMarket",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/FarmersMarket",
    },
    {
        type: "Reddit",
        name: "/r/FarmersMarkets",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/FarmersMarkets",
    },
    {
        type: "Reddit",
        name: "/r/FoodSovereignty",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/FoodSovereignty",
    },
    {
        type: "Reddit",
        name: "/r/Foraging",
        category: "Reddit",
        author: "",
        description: "50,000+ subscribers",
        link: "https://www.reddit.com/r/Foraging",
    },
    {
        type: "Reddit",
        name: "/r/GlutenfreeVegan",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/GlutenfreeVegan",
    },
    {
        type: "Reddit",
        name: "/r/MeatlessMealPrep",
        category: "Reddit",
        author: "",
        description: "50,000+ subscribers",
        link: "https://www.reddit.com/r/MeatlessMealPrep",
    },
    {
        type: "Reddit",
        name: "/r/Nicecream",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Nicecream",
    },
    {
        type: "Reddit",
        name: "/r/Plantbased",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Plantbased",
    },
    {
        type: "Reddit",
        name: "/r/PlantBasedDiet",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/PlantBasedDiet",
    },
    {
        type: "Reddit",
        name: "/r/Raw",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/rhttps://www.reddit.com/raw",
    },
    {
        type: "Reddit",
        name: "/r/RawVegan",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/rhttps://www.reddit.com/rawVegan",
    },
    {
        type: "Reddit",
        name: "/r/Vegrecipes",
        category: "Reddit",
        author: "",
        description: "50,000+ subscribers",
        link: "https://www.reddit.com/r/Vegrecipes",
    },
    {
        type: "Reddit",
        name: "/r/VeganBaking",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/VeganBaking",
    },
    {
        type: "Reddit",
        name: "/r/Vegancheesemaking",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Vegancheesemaking",
    },
    {
        type: "Reddit",
        name: "/r/VeganFoodPorn",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganFoodPorn",
    },
    {
        type: "Reddit",
        name: "/r/VeganFood",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/VeganFood",
    },
    {
        type: "Reddit",
        name: "/r/VeganMealPrep",
        category: "Reddit",
        author: "",
        description: "100,000+ subscribers",
        link: "https://www.reddit.com/r/VeganMealPrep",
    },
    {
        type: "Reddit",
        name: "/r/VeganPizza",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/VeganPizza",
    },
    {
        type: "Reddit",
        name: "/r/VeganGifRecipes",
        category: "Reddit",
        author: "",
        description: "50,000+ subscribers",
        link: "https://www.reddit.com/r/VeganGifRecipes",
    },
    {
        type: "Reddit",
        name: "/r/VeganRecipes",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/VeganRecipes",
    },
    {
        type: "Reddit",
        name: "/r/Veganize",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/Veganize",
    },
    {
        type: "Reddit",
        name: "Edmonton",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/yegvegan",
    },
    {
        type: "Reddit",
        name: "Vegan UK",
        category: "Reddit",
        author: "",
        description: "10,000+ subscribers",
        link: "https://www.reddit.com/r/VeganUK",
    },
    {
        type: "Reddit",
        name: "Germany",
        category: "Reddit",
        author: "",
        description: "",
        link: "https://www.reddit.com/r/suomivegaanit",
    },
]
